var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"reminder",attrs:{"id":"main"}},[_c('div',{staticClass:"wrap1160"},[_c('div',{staticClass:"remind-msg-comp"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('CONTACT_COMPLETION_MESSAGE'))}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }